import React from "react";
export const key = "rrEq919nYkNekVmWJ__LQrgBUTV05E6OXRMrwd1wSCI";



export const Description = ({ children }) => {
return 
(
<div className="description">

<span>Description: </span>

<br></br>

{children}

</div>

);

};

